(function () {
  'use strict';

  // Department menu toggle (mobile). Without JS the list is always visible.
  var toggle = document.querySelector('[data-nav-toggle]');
  var list = document.getElementById('nav-list');
  if (toggle && list) {
    toggle.addEventListener('click', function () {
      var open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
      list.classList.toggle('nav__list--open', !open);
    });
  }

  // Quantity steppers. Delegated, so rows re-rendered by the cart keep working.
  // Buttons are hidden without JS; the number input still works.
  document.addEventListener('click', function (event) {
    var button = event.target.closest ? event.target.closest('[data-qty-delta]') : null;
    if (!button) { return; }
    var wrap = button.closest('[data-qty]');
    var input = wrap ? wrap.querySelector('input') : null;
    if (!input) { return; }
    var delta = parseInt(button.getAttribute('data-qty-delta'), 10) || 0;
    var min = parseInt(input.getAttribute('min') || '0', 10);
    var max = parseInt(input.getAttribute('max') || '99', 10);
    var next = (parseInt(input.value, 10) || 0) + delta;
    input.value = String(Math.min(max, Math.max(min, next)));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // Requisition summary. Quantity changes and removals post to /cart/change.js and the section
  // is re-rendered from Shopify's response (Section Rendering API), so every line total, the
  // subtotal and the header count are the server's. Requests run one at a time in order. If
  // fetch or JSON fails for any reason, the form is submitted the plain way instead.
  var cartRoot = document.querySelector('[data-cart-root]');
  if (cartRoot && window.fetch && window.DOMParser && Element.prototype.closest) {
    var sectionId = cartRoot.getAttribute('data-section-id');
    var changeUrl = cartRoot.getAttribute('data-change-url');
    var cartUrl = cartRoot.getAttribute('data-cart-url');
    var textQuantityError = cartRoot.getAttribute('data-text-quantity-error') || '';
    var textUpdated = cartRoot.getAttribute('data-text-updated') || '';
    var textUpdateError = cartRoot.getAttribute('data-text-update-error') || '';
    var queue = Promise.resolve();

    var fallback = function () {
      var form = cartRoot.querySelector('form');
      if (form) { form.submit(); } else { window.location.reload(); }
    };

    var render = function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var next = doc.querySelector('[data-cart-root]');
      if (!next) { throw new Error('cart section missing from response'); }
      cartRoot.innerHTML = next.innerHTML;
      document.dispatchEvent(new CustomEvent('twd:cart-rendered'));
    };

    var showError = function (text) {
      var box = cartRoot.querySelector('[data-cart-error]');
      if (box && text) { box.textContent = text; box.hidden = false; }
    };

    var announce = function (text) {
      var status = cartRoot.querySelector('[data-cart-status]');
      if (status) { status.textContent = text; }
    };

    var focusTarget = function () {
      var active = document.activeElement;
      if (!active || !cartRoot.contains(active)) { return null; }
      var row = active.closest('tr');
      var key = row ? row.getAttribute('data-line-key') : null;
      if (!key) { return null; }
      var delta = active.getAttribute('data-qty-delta');
      if (delta) { return 'tr[data-line-key="' + key + '"] [data-qty-delta="' + delta + '"]'; }
      if (active.tagName === 'INPUT') { return 'tr[data-line-key="' + key + '"] input'; }
      return null;
    };

    var restoreFocus = function (selector) {
      var el = selector ? cartRoot.querySelector(selector) : null;
      if (!el) { el = cartRoot.querySelector('.cart-table input, .memo .btn'); }
      if (el) { el.focus(); }
    };

    var refresh = function () {
      return fetch(cartUrl + '?section_id=' + encodeURIComponent(sectionId))
        .then(function (res) { return res.text(); })
        .then(render);
    };

    var change = function (key, quantity) {
      var selector = focusTarget();
      cartRoot.setAttribute('aria-busy', 'true');
      return fetch(changeUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity, sections: sectionId, sections_url: cartUrl })
      })
        .then(function (res) {
          return res.json().then(function (json) { return { ok: res.ok, status: res.status, json: json }; });
        })
        .then(function (result) {
          var json = result.json;
          if (!result.ok) {
            // 422 carries a customer-readable reason (sold out, limit); anything else is ours.
            var reason = result.status === 422 ? (json.description || json.message) : '';
            return refresh().then(function () {
              showError(reason || textUpdateError);
              restoreFocus(selector);
            });
          }
          if (!json.sections || !json.sections[sectionId]) { throw new Error('no section in response'); }
          render(json.sections[sectionId]);
          var count = document.getElementById('cart-count');
          if (count) { count.textContent = String(json.item_count); }
          var item = null;
          for (var i = 0; i < json.items.length; i++) {
            if (json.items[i].key === key) { item = json.items[i]; }
          }
          var got = item ? item.quantity : 0;
          // Shopify gives a line a new key when its discounts change (a third tee turns the 3-tee
          // offer on, removing it turns it off), so a key that is gone falls back to the variant's count.
          if (!item) {
            var variantId = key.split(':')[0];
            for (var j = 0; j < json.items.length; j++) {
              if (String(json.items[j].variant_id) === variantId) { got += json.items[j].quantity; }
            }
          }
          if (quantity > 0 && got !== quantity) {
            showError(textQuantityError.replace('[quantity]', String(got)));
          }
          var subtotal = cartRoot.querySelector('[data-cart-subtotal]');
          announce(textUpdated.replace('[subtotal]', subtotal ? subtotal.textContent.trim() : ''));
          restoreFocus(selector);
        })
        .catch(fallback)
        .then(function () { cartRoot.removeAttribute('aria-busy'); });
    };

    var enqueue = function (key, quantity) {
      queue = queue.then(function () { return change(key, quantity); });
    };

    cartRoot.addEventListener('change', function (event) {
      var field = event.target;
      if (!field || field.getAttribute('name') !== 'updates[]') { return; }
      var row = field.closest('tr');
      var key = row ? row.getAttribute('data-line-key') : null;
      var quantity = parseInt(field.value, 10);
      if (!key || isNaN(quantity) || quantity < 0) {
        field.value = field.getAttribute('data-prev') || '1';
        return;
      }
      enqueue(key, quantity);
    });

    cartRoot.addEventListener('click', function (event) {
      var link = event.target.closest('[data-remove]');
      if (!link) { return; }
      var row = link.closest('tr');
      var key = row ? row.getAttribute('data-line-key') : null;
      if (!key) { return; }
      event.preventDefault();
      enqueue(key, 0);
    });

    // Enter in a quantity field would submit the form through the hidden Update button.
    // The change event already handled it; only the checkout button submits. Browsers
    // without event.submitter get the last clicked submit button instead.
    var lastSubmitter = null;
    cartRoot.addEventListener('click', function (event) {
      var button = event.target.closest('button[type="submit"]');
      if (button) { lastSubmitter = button; }
    });
    cartRoot.addEventListener('submit', function (event) {
      var submitter = event.submitter || lastSubmitter;
      lastSubmitter = null;
      if (submitter && submitter.getAttribute('name') === 'checkout') { return; }
      event.preventDefault();
    });
  }

  // Variant picker: swatches for the blank color, buttons for the size. Every option group is a set of
  // radios; the chosen combination is looked up in the variant map and written to the hidden id field.
  // The gallery follows the color: a variant's own image first, else any image of that color, and the
  // thumbnails narrow to that color's images. The plain select is left for browsers without JS.
  var picker = document.querySelector('[data-picker]');
  if (picker) {
    var form = picker.closest('form');
    var variants = [];
    var prices = {};
    try {
      variants = JSON.parse(picker.querySelector('[data-variants]').textContent);
      prices = JSON.parse(picker.querySelector('[data-prices]').textContent);
    } catch (err) { variants = []; }
    var idField = picker.querySelector('[data-variant-id]');
    var legacy = form ? form.querySelector('[data-variant-select]') : null;
    if (variants.length && idField) {
      if (legacy) { legacy.disabled = true; }
      idField.name = 'id';
      var colorIndex = parseInt(picker.getAttribute('data-color-index'), 10);
      var optionCount = parseInt(picker.getAttribute('data-option-count'), 10) || 1;
      var groups = picker.querySelectorAll('[data-opt-group]');
      var priceEl = document.querySelector('[data-price]');
      var compareEl = document.querySelector('[data-compare]');
      var submit = document.querySelector('[data-submit]');
      var stickyPrice = document.querySelector('[data-sticky-price]');
      var shown = document.querySelector('[data-shown]');
      var shownTemplate = shown ? shown.textContent : '';
      var thumbs = document.querySelectorAll('.gallery__thumbs label');

      var colorMedia = {};
      for (var v = 0; v < variants.length; v++) {
        var item = variants[v];
        if (colorIndex >= 0 && item.featured_media && !colorMedia[item.options[colorIndex]]) {
          colorMedia[item.options[colorIndex]] = item.featured_media.id;
        }
      }

      var selected = function () {
        var out = [];
        for (var i = 0; i < optionCount; i++) {
          var radio = picker.querySelector('input[data-opt-index="' + i + '"]:checked');
          out.push(radio ? radio.value : null);
        }
        return out;
      };

      var find = function (opts) {
        for (var i = 0; i < variants.length; i++) {
          var match = true;
          for (var j = 0; j < opts.length; j++) {
            if (opts[j] !== null && variants[i].options[j] !== opts[j]) { match = false; break; }
          }
          if (match) { return variants[i]; }
        }
        return null;
      };

      var labelFor = function (radio) {
        return picker.querySelector('label[for="' + radio.id + '"]');
      };

      // A value is offered when some available variant has it together with the other chosen values.
      var markAvailability = function (opts) {
        for (var g = 0; g < groups.length; g++) {
          var index = parseInt(groups[g].getAttribute('data-opt-index'), 10);
          var radios = groups[g].querySelectorAll('input');
          for (var r = 0; r < radios.length; r++) {
            var probe = opts.slice();
            probe[index] = radios[r].value;
            var found = null;
            for (var i = 0; i < variants.length; i++) {
              var ok = true;
              for (var j = 0; j < probe.length; j++) {
                if (probe[j] !== null && variants[i].options[j] !== probe[j]) { ok = false; break; }
              }
              if (ok && variants[i].available) { found = variants[i]; break; }
            }
            var label = labelFor(radios[r]);
            if (label) { label.setAttribute('data-unavailable', found ? 'false' : 'true'); }
          }
        }
      };

      var showColor = function (variant, color) {
        var mediaId = variant && variant.featured_media ? variant.featured_media.id : (color ? colorMedia[color] : null);
        if (mediaId) {
          var radio = document.getElementById('media-' + mediaId);
          if (radio) { radio.checked = true; markThumb(radio); }
        }
        if (color && thumbs.length) {
          var key = '|' + color + '|';
          var visible = 0;
          for (var t = 0; t < thumbs.length; t++) {
            var colors = thumbs[t].getAttribute('data-colors') || '';
            var show = colors === '' || colors.indexOf(key) !== -1;
            thumbs[t].hidden = !show;
            if (show) { visible++; }
          }
          if (!visible) { for (var u = 0; u < thumbs.length; u++) { thumbs[u].hidden = false; } }
        }
        if (shown && color && shownTemplate) {
          var oldColor = shown.getAttribute('data-color') || '';
          if (!oldColor) { shown.setAttribute('data-color', color); }
          shown.textContent = shownTemplate.replace(shown.getAttribute('data-color'), color);
          shown.setAttribute('data-color', color);
          shownTemplate = shown.textContent;
        }
      };

      // When the chosen color does not come in the chosen size, move the other options to that color's first
      // available variant instead of landing on "Unavailable" (a 5-size white blank next to 7-size blanks).
      var settle = function (changedIndex) {
        var opts = selected();
        if (find(opts) || changedIndex === null) { return; }
        for (var i = 0; i < variants.length; i++) {
          var candidate = variants[i];
          if (candidate.available && candidate.options[changedIndex] === opts[changedIndex]) {
            for (var j = 0; j < optionCount; j++) {
              if (j === changedIndex) { continue; }
              var radio = picker.querySelector('input[data-opt-index="' + j + '"][value="' + candidate.options[j].replace(/"/g, '\\"') + '"]');
              if (radio) { radio.checked = true; }
            }
            return;
          }
        }
      };

      var update = function (changedIndex) {
        settle(typeof changedIndex === 'number' ? changedIndex : null);
        var opts = selected();
        var variant = find(opts);
        var color = colorIndex >= 0 ? opts[colorIndex] : null;
        for (var g = 0; g < groups.length; g++) {
          var index = parseInt(groups[g].getAttribute('data-opt-index'), 10);
          var label = groups[g].querySelector('[data-opt-label]');
          if (label && opts[index] !== null) { label.textContent = opts[index]; }
        }
        markAvailability(opts);
        if (variant) {
          idField.value = variant.id;
          if (legacy) { legacy.value = variant.id; }
          var money = prices[String(variant.id)] || '';
          if (priceEl && money) { priceEl.textContent = money; }
          if (stickyPrice && money) { stickyPrice.textContent = money; }
          if (compareEl) { compareEl.hidden = true; compareEl.textContent = ''; }
          if (submit) {
            submit.disabled = !variant.available;
            submit.textContent = variant.available ? submit.getAttribute('data-label-add') : submit.getAttribute('data-label-unavailable');
          }
          if (window.history && window.history.replaceState) {
            try {
              var url = new URL(window.location.href);
              url.searchParams.set('variant', variant.id);
              window.history.replaceState(null, '', url.toString());
            } catch (e) { /* URL API unavailable; nothing to update */ }
          }
        } else if (submit) {
          submit.disabled = true;
          submit.textContent = submit.getAttribute('data-label-combo') || submit.getAttribute('data-label-unavailable');
        }
        showColor(variant, color);
      };

      picker.addEventListener('change', function (event) {
        if (event.target && event.target.matches && event.target.matches('input[data-opt-index]')) {
          update(parseInt(event.target.getAttribute('data-opt-index'), 10));
        }
      });
      markAvailability(selected());
      showColor(find(selected()), colorIndex >= 0 ? selected()[colorIndex] : null);
    }
  }

  // Sticky requisition bar (phones): appears once the real button has scrolled above the
  // viewport. Read on scroll (a fling can skip an IntersectionObserver transition).
  var stickyBar = document.querySelector('[data-sticky-bar]');
  var mainSubmit = document.querySelector('#requisition [data-submit]');
  if (stickyBar && mainSubmit) {
    var ticking = false;
    var syncBar = function () {
      ticking = false;
      var passed = mainSubmit.getBoundingClientRect().top < 0;
      var show = passed && !mainSubmit.disabled;
      if (stickyBar.hidden === !show) { return; }
      stickyBar.hidden = !show;
      document.body.style.paddingBottom = show ? stickyBar.offsetHeight + 'px' : '';
    };
    var onScroll = function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(syncBar); }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    syncBar();
  }

  // Contact address: assembled from the encoded attribute so the source holds no mailto.
  var emailLinks = document.querySelectorAll('[data-email]');
  for (var e = 0; e < emailLinks.length; e++) {
    try {
      var address = window.atob(emailLinks[e].getAttribute('data-email'));
      if (address.indexOf('@') > 0) {
        emailLinks[e].setAttribute('href', 'mailto:' + address);
        emailLinks[e].textContent = address;
      }
    } catch (err) { /* leave the contact-page link in place */ }
  }

  // Gallery thumbnails: mark the active thumb for styling (the switch itself is CSS).
  function markThumb(radio) {
    var labels = document.querySelectorAll('.gallery__thumbs label');
    for (var k = 0; k < labels.length; k++) {
      labels[k].setAttribute('data-checked', labels[k].getAttribute('for') === radio.id ? 'true' : 'false');
    }
  }
  var radios = document.querySelectorAll('.gallery__radio');
  for (var r = 0; r < radios.length; r++) {
    radios[r].addEventListener('change', function (event) { markThumb(event.currentTarget); });
    if (radios[r].checked) { markThumb(radios[r]); }
  }

  // Close-up peek (snippets/peek-media): with a mouse, the close-ups load once the page has (lazy, so only the cards
  // near the screen, then the rest as they scroll in) and the hover is instant; phones load one on its first touch, so
  // a phone never downloads close-ups nobody asked for. With a mouse, it shows while the mouse is over the card (CSS).
  // On a phone (his 09-30: "i want the close up there until the user touches it again"), a touch that drags 10 px or
  // holds 350 ms on a card flips it to its close-up and it stays (.is-peek); the next one flips it back. A quick tap
  // still just opens the product and leaves the card as it was (no flash).
  var peekBox = function (target) {
    var box = target && target.closest ? target.closest('.card, .attachment') : null;
    var img = box ? box.querySelector('img.peek') : null;
    if (img && img.hasAttribute('data-srcset')) {
      img.setAttribute('srcset', img.getAttribute('data-srcset'));
      img.removeAttribute('data-srcset');
    }
    return img ? box : null;
  };
  var unpeek = function () {
    var on = document.querySelectorAll('.is-peek');
    for (var q = 0; q < on.length; q++) { on[q].classList.remove('is-peek'); }
  };
  var loadPeeks = function () {
    var waiting = document.querySelectorAll('img.peek[data-srcset]');
    for (var q = 0; q < waiting.length; q++) { peekBox(waiting[q]); }
  };
  if (window.matchMedia && window.matchMedia('(hover: hover)').matches) {
    if (document.readyState === 'complete') { loadPeeks(); } else { window.addEventListener('load', loadPeeks); }
  }
  document.addEventListener('mouseover', function (event) { peekBox(event.target); });
  var touch = null;
  var flip = function () {
    if (touch && !touch.flipped) { touch.flipped = true; touch.box.classList.toggle('is-peek'); }
  };
  var moved = function (t) { return t && (Math.abs(t.clientX - touch.x) >= 10 || Math.abs(t.clientY - touch.y) >= 10); };
  var release = function () { if (touch) { clearTimeout(touch.timer); touch = null; } };
  document.addEventListener('touchstart', function (event) {
    release();
    var box = event.touches.length === 1 ? peekBox(event.target) : null;
    if (!box) { return; }
    touch = { box: box, x: event.touches[0].clientX, y: event.touches[0].clientY, flipped: false, timer: setTimeout(flip, 350) };
  }, { passive: true });
  document.addEventListener('touchmove', function (event) {
    if (touch && moved(event.touches[0])) { flip(); }
  }, { passive: true });
  document.addEventListener('touchend', function (event) {
    if (touch && moved(event.changedTouches[0])) { flip(); }
    release();
  });
  document.addEventListener('touchcancel', function () { flip(); release(); });
  window.addEventListener('pageshow', unpeek);
})();
